/**
 * Нормативы: расход замеса на плиту и нормы выхода участков.
 *
 * Это не справочные величины «для сведения»: по расходу на плиту списывается
 * замес от выработки прессовщика, по норме выхода считается отклонение на
 * агломерации и дроблении. Меняются они редко, но по делу — переточили
 * пресс-форму, изменился вес плиты, изменился расход.
 *
 * Поэтому правка требует причины и сохраняется в истории: через полгода
 * вопрос «почему в марте расход был другой» должен иметь ответ.
 */
import { z } from 'zod';
const reasonField = z
    .string()
    .trim()
    .min(3, 'Напишите, почему меняется норматив')
    .max(500);
export const productNormUpdateSchema = z.object({
    productSizeId: z.string().uuid(),
    /** Расход замеса на одну плиту, граммы. */
    mixNormPerPieceG: z.number().int().min(1).max(100_000),
    reason: reasonField,
});
/**
 * Норма выхода задаётся на агрегате, а не на участке: на одном участке
 * гильотина режет без отходов, а дробилка рядом даёт 90%.
 */
export const machineYieldUpdateSchema = z.object({
    machineId: z.string().uuid(),
    /** Норма выхода в базисных пунктах: 8500 = 85%. Больше 100% не бывает. */
    yieldBp: z.number().int().min(1).max(10_000),
    reason: reasonField,
});
/** Потери при переплавке брака — это свойство участка, а не отдельной линии. */
export const siteNormUpdateSchema = z.object({
    siteId: z.string().uuid(),
    key: z.enum(['REWORK_LOSS_BP']),
    valueBp: z.number().int().min(0).max(10_000),
    reason: reasonField,
});
//# sourceMappingURL=norms.js.map